// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__2aiZO","disabled":"Chip_disabled__188IZ","close-icon":"Chip_close-icon__3kldm","chip-value":"Chip_chip-value__3jo62"};